<div class="container">
  <div class="card" >
    <mat-card class="backGroundGrey">
      <div *ngFor="let page of StatusResponses; let i = index;">
        <div [className]="i == 0 ? 'firstProduct' : 'secondaryProduct'"></div>
        <mat-card-title class="bottomPadding" >{{page.label}}</mat-card-title>
        <div class="bottomPadding" *ngFor="let region of page.availableRegions">
            <mat-card class="buttonHover" (click)="navigateToDetailPage(i, region.name)">
              <mat-card-subtitle>

                <!--All Systems Operational `"description":"All Systems Operational"`-->
                <mat-icon
                  *ngIf="(region.statusDescription.toLowerCase().includes('all systems operational'))"
                  class="icon operationalGreen"
                  aria-hidden="false" aria-label="available icon">done_outline</mat-icon>

                <!--Degraded Performance `"description":"Partially Degraded Service"`-->
                <mat-icon
                  *ngIf="(region.statusDescription.toLowerCase().includes('partially degraded service'))"
                  class="icon degradedPerformanceYellow"
                  aria-hidden="false" aria-label="available icon">do_not_disturb_on</mat-icon>

                <!--Partial Service Outage `"description":"Minor Service Outage"`-->
                <mat-icon
                  *ngIf="(region.statusDescription.toLowerCase().includes('minor service outage'))"
                  class="icon minorOutageOrange"
                  aria-hidden="false" aria-label="available icon">error</mat-icon>

                <!--Major Outage `"description":"Partial System Outage"`-->
                <mat-icon
                  *ngIf="(region.statusDescription.toLowerCase().includes('partial system outage'))"
                  class="icon majorOutageRed"
                  aria-hidden="false" aria-label="available icon">dangerous</mat-icon>

                <!--Future proof for if the API ever returns  `"description":"Major System Outage"`-->
                <mat-icon
                  *ngIf="(region.statusDescription.toLowerCase().includes('major system outage'))"
                  class="icon majorOutageRed"
                  aria-hidden="false" aria-label="available icon">dangerous</mat-icon>

                <!--Future proof for if the API ever returns  `"description":"Major Service Outage"`-->
                <mat-icon
                  *ngIf="(region.statusDescription.toLowerCase().includes('major service outage'))"
                  class="icon majorOutageRed"
                  aria-hidden="false" aria-label="available icon">dangerous</mat-icon>

                <!--Under Maintenance `"description":"Service Under Maintenance"`-->
                <mat-icon
                  *ngIf="(region.statusDescription.toLowerCase().includes('service under maintenance'))"
                  class="icon underMaintenanceBlue"
                  aria-hidden="false" aria-label="available icon">build_circle</mat-icon>

                <!--Unknown Status Description-->
                <mat-icon
                  *ngIf="!(
                  region.statusDescription.toLowerCase().includes('all systems operational') ||
                  region.statusDescription.toLowerCase().includes('partially degraded service') ||
                  region.statusDescription.toLowerCase().includes('minor service outage') ||
                  region.statusDescription.toLowerCase().includes('partial system outage') ||
                  region.statusDescription.toLowerCase().includes('major system outage') ||
                  region.statusDescription.toLowerCase().includes('major service outage') ||
                  region.statusDescription.toLowerCase().includes('service under maintenance'))"
                  class="icon minorOutageOrange"
                  aria-hidden="false" aria-label="available icon">sync</mat-icon>

                <!--Status API is returning an empty string-->
                <span *ngIf="(region.statusDescription.length == 0)"
                      class="largerFont">{{region.name}} - Status Unknown</span>

                <!--Status API is returning 'partial system outage' for a major system outage-->
                <span *ngIf="(region.statusDescription.toLowerCase().includes('partial system outage') &&
                  region.statusDescription.length > 0)"
                      class="largerFont">{{region.name}} - Major Service Outage</span>

                <span *ngIf="(!region.statusDescription.toLowerCase().includes('partial system outage') &&
                  region.statusDescription.length > 0)"
                      class="largerFont">{{region.name}} - {{region.statusDescription}}</span>

              </mat-card-subtitle>
            </mat-card>
        </div>
      </div>
    </mat-card>
  </div>
</div>
